/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


/**
 * JS IS ENABLED
 */
var html = document.getElementsByTagName("html")[0];
if(html.className === "no-js") {
  html.className = html.className.replace("no-js", "js"); // user has JS enabled
}


/**
 * SITE IS LOADED
 */
jQuery(document).ready(function($) {
    $(window).load(function() {
        $('body').addClass("my-body-is-ready");
    });
});

/**
 * Add sub-submenu
 */
jQuery(document).ready(function($) {
  var sub_element = "nav ul > li > ul > li.dropdown > a";
  $(sub_element).attr("data-toggle","dropdown");
  $(sub_element).attr("data-target","#");
  $(sub_element).addClass("dropdown-toggle");
  $(sub_element).closest("li").toggleClass("open");
  $(sub_element).addClass("right-caret");
  $(sub_element).append('<b class="caret right-caret "></b>');
  $(sub_element).click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    $(e.target).closest("li").toggleClass("open");
    $(e.target).attr("aria-expanded","true");
  });

  $(".dropdown-menu > li > a.trigger").on("click",function(e){
    var current=$(this).next();
    var grandparent=$(this).parent().parent();
    if($(this).hasClass('left-caret')||$(this).hasClass('right-caret')) {
      $(this).toggleClass('right-caret left-caret');
    }
    grandparent.find('.left-caret').not(this).toggleClass('right-caret left-caret');
    grandparent.find(".sub-menu:visible").not(current).hide();
    current.toggle();
    e.stopPropagation();
  });
  $(".dropdown-menu > li > a:not(.trigger)").on("click",function(){
    var root=$(this).closest('.dropdown');
    root.find('.left-caret').toggleClass('right-caret left-caret');
    root.find('.sub-menu:visible').hide();
  });
});

function post(path, params, method) {
  method = method || "post"; // Set method to post by default if not specified.

  // The rest of this code assumes you are not using a library.
  // It can be made less wordy if you use one.
  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    if(params.hasOwnProperty(key)) {
      var hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", key);
      hiddenField.setAttribute("value", params[key]);

      form.appendChild(hiddenField);
    }
  }

  document.body.appendChild(form);
  form.submit();
}



/**
 * ABOUT US AND PRICES PAGE
*/
jQuery(document).ready(function($) {
  if (("ontouchstart" in document.documentElement)) {
    $('html').addClass('touch');
  } else {
    $('html').addClass('no-touch');
  }
/*
  $('#open_prijzen').on('click', function(e) {
    "use strict";
    //e.preventDefault();
   // $('.prices').click();
    $('.prices').toggleClass('view-tab');
    $('footer.content-info, .prices').attr('aria-selected', 'false');
    $('.prices').attr('aria-selected', 'true');
  });
  $('#open_contact').on('click', function(e) {
    "use strict";
   // e.preventDefault();
    //$('footer.content-info').click();
    $('footer.content-info').toggleClass('view-tab');
    $('footer.content-info, .prices').attr('aria-selected', 'false');
    $('footer.content-info').attr('aria-selected', 'true');
  });
*/
  $('footer.content-info, .prices').on('click', function(e) {
      "use strict";
      $(e.target).toggleClass('view-tab');

    });
  $('footer.content-info .panel-close, .prices .panel-close').on('click', function(e) {
    "use strict";
    $(e.target).closest('footer.content-info, .prices').toggleClass('view-tab');
    $('footer.content-info, .prices').attr('aria-selected', 'false');
    $(e.target).attr('aria-selected', 'true');

  });
});

/**
 * LOAD HOMEPAGE ARTICLES IN SIDEBAR
 */

function getFPPost(post_id) {
  var inner_data = document.createElement('div');
  jQuery(document).ready(function($) {
    $('.logo a').addClass('spin');
    $('.latest-posts #loadpost_'+post_id).addClass('loading');
    $('.latest-work').removeClass('work-loaded');
    document.getElementById('post-content-loader').scrollTop = 0;
    $.getJSON( "wp-json/wp/v2/posts/" + post_id, function( data ) {

    }).done(function(data) {
      inner_data = document.createElement('div');
      if (data.featured_media > 0) {
        $.getJSON( "wp-json/wp/v2/media/" + data.featured_media, function( img_data ) {

        }).done(function(img_data) {
          "use strict";
          if (typeof img_data.media_details.sizes['header-image'] !== 'undefined') {
            $(inner_data).append('<img class="featured-image" src="' + img_data.media_details.sizes['header-image'].source_url + '" alt="' + img_data.alt_text + '" title="' + img_data.title.rendered + '" />')
          } else {
            $(inner_data).append('<img class="featured-image" src="' + img_data.media_details.sizes['full'].source_url + '" alt="' + img_data.alt_text + '" title="' + img_data.title.rendered + '" />')
          }
          $(inner_data).append('<h2>' + data.title.rendered + '</h2>');
          $(inner_data).append(data.content.rendered);
          $('#post-content-loader').html(inner_data);
          $('.latest-work').addClass('work-loaded');
          $('.header-news').addClass('scrolled');
          $('.header-news').slideUp();
        });
      } else {
        $(inner_data).append('<h2>' + data.title.rendered + '</h2>');
        $(inner_data).append(data.content.rendered);
        $('#post-content-loader').html(inner_data);
        $('.latest-work').addClass('work-loaded');
        $('.header-news').addClass('scrolled');
        $('.header-news').slideUp();
      }
      setTimeout(function(){
        $('.latest-posts #loadpost_'+post_id).removeClass('loading');
      }, 800);
    });
  });
}

function getFPPost_specific(post_id) {
  var inner_data = document.createElement('div');
  jQuery(document).ready(function($) {
    $('.logo a').addClass('spin');
    $('.latest-posts #loadpost_'+post_id).addClass('loading');
    $('.latest-work').removeClass('work-loaded');
    document.getElementById('post-content-loader').scrollTop = 0;
    $.getJSON( "wp-json/homepost/v1/post/" + post_id, function( data ) {
    }).done(function(data) {
      inner_data = document.createElement('div');
      $(inner_data).append(data.content);
      $('#post-content-loader').html(inner_data);
      $('.latest-work').addClass('work-loaded');
      $('.header-news').addClass('scrolled');
      $('.header-news').slideUp();
      setTimeout(function(){
        $('.latest-posts #loadpost_'+post_id).removeClass('loading');
      }, 800);
    }).fail(function(jqXHR, textStatus, errorThrown) { console.log('getJSON request failed! ' + textStatus); });
  });
}

jQuery(document).ready(function($) {
    if ($('body').hasClass('home')) {
      $('.post-content-loader-container .panel-close').on('click', function() {
        "use strict";
        $('.latest-posts ul li > a').removeClass('active');
        $('.latest-work').removeClass('work-loaded');
        $('.latest-work').attr('aria-selected', 'false');
      });
      $('html').addClass('htmlhome');
      $('.latest-posts ul li:not(.blog-link) > a').on('click', function (e) {
        "use strict";
        e.stopPropagation();
        e.preventDefault();
        if (!$(e.target).hasClass('active') && !$(e.target).closest('.loadpost').hasClass('active')) {
          var this_post_id = '';
          $('.latest-posts ul li > a').removeClass('active');
          if ($(e.target).hasClass('loadpost')) {
            this_post_id = $(e.target).attr('id').split('_')[1];
            $(e.target).addClass('active');
          } else {
            this_post_id = $(e.target).closest('.loadpost').attr('id').split('_')[1];
            $(e.target).closest('.loadpost').addClass('active');
          }
          getFPPost_specific(this_post_id);
          $('.latest-work').attr('aria-selected', 'true');
        }
      });
    } else {
      $('html').addClass('htmlnothome');
    }
});


/**
 * CLOSE BUTTON FOOTER
 */

jQuery(document).ready(function($) {
    $('.footer.content-info .panel-close').on('click', function() {
      "use strict";
      $('footer.content-info').removeClass('view-about');
    });
});


/**
 * Hide Header on on scroll down
 * http://jsfiddle.net/mariusc23/s6mLJ/31/
 */
var didScroll;
var lastScrollTop = 0;
var delta = 1;
var navbarElement = 'header.banner';
var navbarHeight = 10;//jQuery(navbarElement).outerHeight();

jQuery(document).ready(function($) {
  $(window).scroll(function(event){
    didScroll = true;
  });

  function hasScrolled() {
    var st = $(this).scrollTop();

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) {
      return;
    }
    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st < 10) {
      $(navbarElement).removeClass('nav-up').removeClass('nav-down');
    } else {
      if (st > lastScrollTop && st > navbarHeight) {
        // Scroll Down
        $(navbarElement).removeClass('nav-down').addClass('nav-up');
        $('.header-news').addClass('scrolled');
        $('.home .header-news').slideUp();
      } else {
        // Scroll Up
        if (st + $(window).height() < $(document).height()) {
       //   $(navbarElement).removeClass('nav-up').addClass('nav-down');
        }
      }
    }
    lastScrollTop = st;
  }

  setInterval(function() {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 250);

});


/**
 * IS MOBILE
 */

var isMobile = {
  Android: function() {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function() {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function() {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function() {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function() {
    return navigator.userAgent.match(/IEMobile/i);
  },
  any: function() {
    return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
  }
};
if( isMobile.any() ) {
  jQuery(document).ready(function($) {
    $('body').addClass('is-mobile')
  });
}
